import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '../../context/authContext'
import logo from '../../assets/images/login-logo.png'
import { TextField } from '../../components/styledFormElements/TextField'
import { twElementStyles } from '../../twElementStyles'
import { useState } from 'react'
import { Loader } from '../../components/loader'
import { useSendResetPasswordLink } from '../../hooks/user'
import { CheckCircleIcon, EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline'
const schema = yup
    .object({
        email: yup.string().email().required(),
        password: yup.string().required(),
    })
    .required()
export const Login: React.FC<any> = (props) => {
    const auth = useAuth()
    const [searchParams] = useSearchParams()
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState(false)
    const { mutate: sendResetPwdLink, isLoading: isLoadingPwd } = useSendResetPasswordLink()
    const [error, setError] = useState<any>(null)
    const redirectTo = searchParams.get('redirectTo') ?? '/'

    const [forgotPwd, setForgotPwd] = useState(false)
    const [showPassword, setShowPassword] = useState(false)

    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(schema),
    })

    const handleLogin = (data) => {
        setIsLoading(true)
        auth?.login({
            email: data.email,
            password: data.password
        }, (response) => {
            setIsLoading(false)
            navigate(redirectTo, { replace: true })
        }, (error) => {
            setIsLoading(false)
            setError(error)
        })
    }

    const [linkSent, setLinkSent] = useState(false)
    const handleFpwd = (data) => {
        sendResetPwdLink({
            data: {
                email: data?.email
            }
        }, {
            onSuccess: () => {
                setLinkSent(true)
            }
        })
    }

    const onSubmit = handleSubmit(forgotPwd ? handleFpwd : handleLogin)

    return (
        <div className="min-h-screen dark:bg-slate-700 bg-slate-200 flex flex-col flex-grow justify-center py-12 px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md mb-20">
                <div className=" py-10 px-10 rounded-lg bg-white dark:bg-slate-800 ">
                    <img src={logo} alt="logo" className="mb-4 my-5 h-20 mx-auto block dark:hidden" />
                    <img src={logo} alt="logo" className="mb-4 my-5 h-20 mx-auto hidden dark:block" />
                    {
                        linkSent ?
                            <>
                                <div className='flex items-center gap-4 dark:text-white'>
                                    <CheckCircleIcon className='w-6 h-6 text-green-600'/> Reset password link has been sent to registered email address <span className='underline font-semibold cursor-pointer' onClick={()=> {
                                        setForgotPwd(false);
                                        setLinkSent(false);
                                    }} >Login</span> 
                                </div>
                            </>
                            :
                            <form
                                onSubmit={onSubmit}
                                className="mb-0 py-5"
                                noValidate
                            >
                                <div className="my-2">
                                    <TextField placeholder='xyz@abc.com' autoFocus register={register('email')} errors={errors} label="Email:" />
                                </div>
                                {
                                    !forgotPwd &&
                                    <div className="my-2">
                                        <div className="relative">
                                            <TextField
                                                register={register('password')}
                                                type={showPassword ? 'text' : 'password'}
                                                errors={errors}
                                                label="Password:"
                                                style={{ paddingRight: '2.75rem' }}
                                            />
                                            <button
                                                type="button"
                                                aria-label={showPassword ? 'Hide password' : 'Show password'}
                                                // onMouseDown={(e) => e.preventDefault()}
                                                onClick={() => setShowPassword((prev) => !prev)}
                                                className="absolute right-2 top-6 -translate-y-1/2 text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
                                            >
                                                {showPassword ? (
                                                    <EyeSlashIcon className="w-5 h-5" />
                                                ) : (
                                                    <EyeIcon className="w-5 h-5" />
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                }
                                <div className='w-full mt-5'>
                                    {
                                        forgotPwd ?
                                            <button disabled={isLoadingPwd} type="submit" className={twElementStyles.twButtonPrimary + ' w-full py-3'} >
                                                {isLoadingPwd ? (
                                                    <><Loader /> Sending verification link ...</>
                                                ) : 'Send verification link'}
                                            </button>
                                            :
                                            <button disabled={isLoading} type="submit" className={twElementStyles.twButtonPrimary + ' w-full py-3'} >
                                                {isLoading ? (
                                                    <><Loader /> Logging in ...</>
                                                ) : 'Login'}
                                            </button>
                                    }


                                    {
                                        error && !forgotPwd &&
                                        error?.response?.data?.statusCode === 401 &&
                                        <div className="mb-4 text-sm text-red-600  dark:text-red-400" role="alert">
                                            <span className="">Invaid credentials !</span>
                                        </div>
                                    }
                                    <p className='float-right text-gray-800 dark:text-gray-200'>
                                        <span
                                            className="underline cursor-pointer"
                                            onClick={() => {
                                                setForgotPwd(!forgotPwd)
                                                setShowPassword(false)
                                            }}
                                        >
                                            {
                                                !forgotPwd ? `Forgot password ?` : 'Login'
                                            }
                                        </span>
                                    </p>
                                </div>
                            </form>
                    }


                </div>
            </div>
        </div>
    )
}
